/**
 * A search value as the string every page reads it as.
 *
 * The router JSON-parses search params, so `?email=123` arrives as the number `123`, `?type=true`
 * as the boolean, and an all-digit id as a number. Each of those is an ordinary thing to put in
 * a URL, so take its string form. Anything else — null, an object, an array — is not a scalar
 * anyone typed, and stays absent, which a page can tell apart from an empty value.
 */
export function searchString(value: unknown): string | undefined {
  if (typeof value === 'string') {
    return value;
  }
  if (typeof value === 'number' && Number.isFinite(value)) {
    return String(value);
  }
  if (typeof value === 'boolean') {
    return String(value);
  }
  return undefined;
}
